import javascript from '../Assets/javascript.png';
import node from '../Assets/node.png';
import python from '../Assets/python.png';
import react from '../Assets/react.png';
import profile from '../Assets/profile.png';
import circle from '../Assets/circle.svg';
import logo from '../Assets/logo.png';
import unity from '../Assets/unity.png'
import dotnet from '../Assets/dotnet.png'

export default {
  javascript,
  node,
  python,
  react,
  profile,
  circle,
  logo,
  unity,
  dotnet
};